import axios from "axios";

let apiInstance = null;

const loadConfig = async () => {
  const response = await fetch("/config.json");
  const config = await response.json();
  return config;
};

export const initializeApi = async (onUnauthorized) => {
  if (!apiInstance) {
    const config = await loadConfig();
    apiInstance = axios.create({
      baseURL: config.REACT_APP_API_URL,
      withCredentials: true,
    });

    apiInstance.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("token");
        if (token) {
          config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

apiInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          if (onUnauthorized) {
            onUnauthorized();
          }
        }
        return Promise.reject(error);
      }
    );

  }
  return apiInstance;
};

export const getApiInstance = () => {
  if (!apiInstance) {
    throw new Error("API not initialized. Call initializeApi first.");
  }
  return apiInstance;
};

export const tableService = {
  create: async (url, data) => {
    const api = getApiInstance();
    return api.post(url, data)
  },
  update: async (url, id, data) => {
    const api = getApiInstance();
    return api.put(url, data);
  },
  updateBulk: async (url, data) => {
    const api = getApiInstance();
    return api.put(url, data);
  },
  delete: async (url, id) => {
    const api = getApiInstance();
    return api.delete(`${url}/${id}`);
  },
};


function hasFileInData(data)  {
  // Caso 1: si data ya es un FormData, podemos comprobar sus entries
  if (data instanceof FormData) {
    for (const [key, value] of data.entries()) {
      // FormData#entries devuelve [campo, valor] donde valor puede ser File, Blob, string, etc.
      if (value instanceof File || value instanceof Blob) {
        return true;
      }
    }
    return false;
  }

  // Caso 2: objeto plano con propiedades
  for (const key in data) {
    if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
    const value = data[key];
    if (value instanceof File || value instanceof Blob) {
      return true;
    }
    // Si el valor es un array, recorrerlo
    if (Array.isArray(value)) {
      for (const el of value) {
        if (el instanceof File || el instanceof Blob) {
          return true;
        }
      }
    }
    // Si es un objeto, hacer recursivamente
    if (value && typeof value === 'object' && !(value instanceof Date)) {
      if (hasFileInData(value)) {
        return true;
      }
    }
  }

  return false;
}

function formDataHasFile(formData) {
  for (const [key, value] of formData.entries()) {
    if (value instanceof File || value instanceof Blob) {
      return true;
    }
  }
  return false;
}

function objectHasFile(obj) {
  for (const key in obj) {
    if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
    const value = obj[key];
    if (value === null || value === undefined) continue;
    if (value instanceof File || value instanceof Blob) return true;
    if (Array.isArray(value)) {
      for (const el of value) {
        if (el instanceof File || el instanceof Blob) return true;
      }
    }
    if (typeof value === 'object' && !(value instanceof Date)) {
      if (objectHasFile(value)) return true;
    }
  }
  return false;
}